import { createTheme } from "@mui/material/styles";

// pale grey #CCD9DD 100%
// pale grey #E6ECEE 50%
// pale grey #F2F6F7 25%
// purple #3E4066
//new styles
//secondray:FFA654
const theme = createTheme({
  palette: {
    primary: {
      main: "#002655", // orange
    },
    secondary: {
      main: "#FFA654", // blue
    },
    success: {
      main: "#5DB661", // green
    },
    error: {
      main: "#ff604f",
    },
    // error: {
    //   main: red.A400,
    // },
    background: {
      default: "#fff",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: [
      '"Helvetica Neue"',
      "Helvetica",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Lato",
      "Roboto",
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h2: {
      fontSize: "40px",
      fontWeight: " bold",
      color: "#002655",
      "@media (max-width: 1000px)": {
        fontSize: "24px",
      },
    },
    h3: {
      fontSize: "20px",
      fontWeight: "800 medium",
      color: "#5db2e3",
    },
    h4: {
      fontSize: "34px",
      fontWeight: "bold",
      color: "#393C74",
      // "@media (max-width: 1000px)": {
      //   fontSize: "24px",
      // },
    },
    h5: {
      fontSize: "28px",
      fontWeight: "500 bold",
      color: "000000",
      "@media (max-width: 1000px)": {
        fontSize: "24px",
      },
    },
    h6: {
      fontSize: "20px",
      fontWeight: "700 bold",
      color: "000000",
    },
    body1: {
      fontSize: "14px",
      color: "#002655",
    },
    body2: {
      fontSize: "16px",
      font: "Helvetica Neue",
      fontWeight: "400 regular",
    },
    subtitle2: {
      fontSize: "18px",
      fontWeight: "700 bold",
      color: "#002655",
    },
    caption: {
      fontSize: "12px",
      color: "#00000061",
      fontWeight: "400 regular",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          padding: "6px 24px",
          fontWeight: "bold",
          textTransform: "none",
          borderRadius: "24px",
          "&:hover": {
            backgroundColor: "#fff",
            color: "#001E43",
          },
        },
        outlinedPrimary: {
          padding: "6px 24px",
          fontWeight: "bold",
          textTransform: "none",
          borderRadius: "24px",
          fontStyle: "italic",
        },
        contained: {
          "&$disabled": {
            backgroundColor: "#fff",
            color: "#002655",
            boxShadow:
              "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
          },
        },
        containedPrimary: {
          borderRadius: "24px",
          padding: "6px 24px",
          color: "#001E43",
          textTransform: "none",
          fontStyle: "italic",
          transition: "all 0.3s ease-out",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "#fff",
            color: "#001E43",
          },
        },
        containedSecondary: {
          borderRadius: "20px",
          padding: "6px 24px",
          color: "#001E43",
          textTransform: "none",
          transition: "all 0.3s ease-out",
          "&:hover": {
            backgroundColor: "#fff",
            color: "#002655",
          },
        },
        outlinedSecondary: {
          borderRadius: "20px",
          padding: "6px 24px",
          color: "#001E43",
          textTransform: "none",
          transition: "all 0.3s ease-out",
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "#FFA654",
            color: "#001E43",
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
        underlineHover: {
          textDecoration: "underline",
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: "#002655",
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: "10px !important",
          backgroundColor: "#E4EAEB !important",
          "&&&:before": {
            borderBottom: "none",
          },
          "&&:after": {
            borderBottom: "none",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          backgroundColor: "#E4EAEB !important",
        },
        input: {
          padding: "18.5px 24px",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          borderRadius: "4px !important",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "14px",
          backgroundColor: "rgb(66,66,66)",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          padding: "34px",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          paddingTop: "10px",
          paddingBottom: "10px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "18px",
          textTransform: "capitalize",
          marginTop: "8px",
          marginBottom: "8px",
          alignItems: "flex-end",
          paddingEnd: "12px",
          "@media (max-width: 960px)": {
            alignItems: "center",
            paddingEnd: "0",
          },
        },
      },
    },
  },
});

export default theme;
